var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 38,
    viewBox: "0 0 54 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1877_30)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H50C52.2091 0 54 1.79086 54 4V27.6667C54 29.8758 52.2091 31.6667 50 31.6667L9 31.6667L0 38V27.6667V25.3333V4ZM18 19.0001C19.6569 19.0001 21 17.5823 21 15.8334C21 14.0845 19.6569 12.6667 18 12.6667C16.3431 12.6667 15 14.0845 15 15.8334C15 17.5823 16.3431 19.0001 18 19.0001ZM30 15.8334C30 17.5823 28.6569 19.0001 27 19.0001C25.3431 19.0001 24 17.5823 24 15.8334C24 14.0845 25.3431 12.6667 27 12.6667C28.6569 12.6667 30 14.0845 30 15.8334ZM36 19.0001C37.6569 19.0001 39 17.5823 39 15.8334C39 14.0845 37.6569 12.6667 36 12.6667C34.3431 12.6667 33 14.0845 33 15.8334C33 17.5823 34.3431 19.0001 36 19.0001Z",
    fill: "#7FC5BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 38,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.29c99ac1a18dd6aa8466e03014322445.svg";
export { ForwardRef as ReactComponent };